import { Component, OnInit } from "@angular/core";
import { AccountService } from "../../models/account.service";

@Component({
  selector: "ab-deprecated-heroku-email-warning-alert",
  templateUrl: "./deprecated-heroku-email-warning.component.html",
})
export class DeprecatedHerokuEmailWarningAlertComponent implements OnInit {
  public show: boolean;

  constructor(private accountService: AccountService) {}

  public close() {
    this.show = false;
  }

  public ngOnInit() {
    this.show = false;

    this.accountService.properties().subscribe((props: any) => {
      this.show = props.alerts
        ? props.alerts.deprecated_heroku_email_alert === true
        : false;
    });
  }
}
